import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ChatParam } from '../models/chat-param';
import { DisplaySetting } from '../models/display-setting';

@Injectable({
    providedIn: 'root'
})
export class PreChatService {
    readonly chatParams$ = new BehaviorSubject<ChatParam[]>([]);
    readonly chatTaskData$ = new BehaviorSubject<ChatParam[]>([]);
    public activeChatData$ = new Subject<any>();
    public invitationAccepted$ = new BehaviorSubject<boolean>(false);
    public reactiveFormSubmit$ = new Subject<boolean>();
    public errorMessage$ = new Subject<string>();

    constructor(private http: HttpClient) {
        window.addEventListener("message", (event) => {
            this.receiveMessage(event);
        });
    }

    bindToMessageEvents(): Observable<ChatParam[]> {
        return this.chatParams$.asObservable();
    }

    bindToCustomTaskData(): Observable<ChatParam[]> {
        return this.chatTaskData$.asObservable();
    }

    receiveMessage(event) {
        if (!event.data) return;
        console.debug('[PreChatService] Received %c%s', 'color:magenta', event.data.message);
        switch (event.data.message) {
            case 'uwfSetChatParams':
                let params: ChatParam[] = event.data.params || [];
                this.chatParams$.next(params);
                break;
            case 'uwfSetChatTaskData':
                let taskData: ChatParam[] = event.data.params || [];
                this.chatTaskData$.next(taskData);
                break;
            case 'uwfInvitationAccepted':
                this.invitationAccepted$.next(event.data.invitationAccepted);
                break;
            case 'uwfActiveChatData':
                this.activeChatData$.next(event.data);
                break;
            case 'uwReactiveFormSubmit':
                this.reactiveFormSubmit$.next(event.data.submit);
                break;
            case 'uwfErrorMessage':
                this.errorMessage$.next(event.data.text);
                break;
            default:
                console.warn('[PreChatService] Unknown message received:', event.data.message);
        }
    }

    hideChat(): void {
        parent.postMessage('uwfRecreateChat', '*');
    }

    hideChatButton(): void {
        parent.postMessage('uwfHideChatButton', '*');
    }

    getPreChatForm(lang: string, formTag: string) {
        return this.http.get<any>(`/api/ChatAdminSettings/GetPrechatForm/${lang}/${formTag}`);
    }

    getDisplaySetting(id: number) {
        return this.http.get<DisplaySetting>(`/api/ChatAdminSettings/DisplaySetting/${id}`);
    }

    getTimeZone() {
        return upstream.customerchat.helpers.GetTimeZoneName();
    }

    setFormSubmitted() {
        parent.postMessage('uwfSetFormSubmitted', '*');
    }

    showPreChatFormForProactive() {
        parent.postMessage('uwfShowChatForActiveSession', '*');
    }

    sendChatFrameLoadEvent() {
        parent.postMessage("uwfChatFrameLoaded", "*");
    }

    sendPreChatFormReadyEvent(skillAddressesFromPreChatForm, formType) {
        parent.postMessage({
            message: 'uwfPreChatFormReady',
            skillAddressesFromPreChatForm: skillAddressesFromPreChatForm,
            formType: formType
        }, '*')
    }

    logEvent(logEventCode: number, logEventDescription: string) {
        parent.postMessage({
            message: 'uwfLogEvent',
            eventCode: logEventCode,
            eventDescription: logEventDescription
        }, '*');
    }

    sendProactiveErrorMessage(errorMessage: string) {
        parent.postMessage({ message: 'uwfProactiveError', error: errorMessage }, "*");
    }
}
